import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-coordinate",
  "use": "icon-coordinate-usage",
  "viewBox": "0 0 1034 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1034 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-coordinate\"><path d=\"M279.04 1024h-102.4V826.88H0v-102.4h176.64V204.8h-92.16l143.36-204.8 143.36 204.8h-92.16v519.68H824.32v-76.8l204.8 143.36-204.8 143.36v-107.52H279.04V1024z\" fill=\"currentColor\" p-id=\"6367\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol